export const revenueQueryTypes = {
  REVENUE: 'REVENUE',
  TRANSACTIONS: 'TRANSACTIONS',
  ARPPU: 'ARPPU',
  ARPU: 'ARPU',
  PAYERS: 'PAYING SHARE, %',
};

export const revenueQueryTypesView = {
  [revenueQueryTypes.REVENUE]: 'Revenue',
  [revenueQueryTypes.TRANSACTIONS]: 'Transactions',
  [revenueQueryTypes.ARPPU]: 'ARPPU',
  [revenueQueryTypes.ARPU]: 'ARPU',
  [revenueQueryTypes.PAYERS]: 'Paying share, %',
};
